import { css } from 'styled-system/css';
import { RoutineRow } from './RoutineRow';

export function RoutinesOverlay() {
  return (
    <div
      className={css({
        position: 'absolute',
        inset: '3',
        left: 'auto',
        zIndex: 2,
        width: { base: '58%', md: '46%' },
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'none',
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '3',
          flex: 1,
          minHeight: 0,
          padding: '4',
          background: 'bg.surface',
          border: '1px solid token(colors.border.hairline)',
          borderRadius: '12px',
          overflow: 'hidden',
        })}
      >
        <span>Routines</span>
        <RoutineRow name="BTC / USD" when="Every weekday 09:00" />
        <RoutineRow name="Operating cash" when="Every morning" />
        <RoutineRow name="Peer comps" when="Mondays 07:30" />
      </div>
    </div>
  );
}
